import { PayloadAction } from '@reduxjs/toolkit';
import type { Marker } from 'minerva-plugin-api';
import { MarkersState } from './markers.types';

export const setMarkersDataReducer = (
  state: MarkersState,
  action: PayloadAction<Marker[]>,
): void => {
  const { payload } = action;

  state.data = payload;
};

export const addMarkerToMarkersDataReducer = (
  state: MarkersState,
  action: PayloadAction<Marker>,
): void => {
  const { payload } = action;

  state.data.push(payload);
};

export const updateMarkerInMarkersDataReducer = (
  state: MarkersState,
  action: PayloadAction<Marker>,
): void => {
  const { payload } = action;

  // replaced in place, so the marker keeps its drawing order
  state.data = state.data.map(m => (m.id === payload.id ? payload : m));
};

export const removeMarkerFromMarkersDataReducer = (
  state: MarkersState,
  action: PayloadAction<string>,
): void => {
  const currentMarkers = state.data;
  const { payload: markerId } = action;
  const newMarkers = currentMarkers.filter(m => m.id !== markerId);

  state.data = newMarkers;
};
